module.exports = __webpack_public_path__ + "static/project-5b-3ce452eb4fc20c01185e00fd38d84d39.png";